var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.26337 1.81934C5.93944 1.82084 4.67018 2.34743 3.73402 3.28358C2.79787 4.21974 2.27128 5.489 2.26978 6.81293C2.26978 11.0858 6.8094 14.313 7.0029 14.448C7.07923 14.5015 7.17017 14.5302 7.26337 14.5302C7.35656 14.5302 7.4475 14.5015 7.52383 14.448C7.71733 14.313 12.257 11.0858 12.257 6.81293C12.2555 5.489 11.7289 4.21974 10.7927 3.28358C9.85655 2.34743 8.58729 1.82084 7.26337 1.81934ZM7.26337 4.99707C7.62251 4.99707 7.97358 5.10357 8.2722 5.3031C8.57081 5.50263 8.80356 5.78623 8.94099 6.11803C9.07843 6.44983 9.11439 6.81494 9.04433 7.16718C8.97426 7.51942 8.80132 7.84297 8.54737 8.09693C8.29341 8.35088 7.96986 8.52382 7.61762 8.59389C7.26538 8.66395 6.90027 8.62799 6.56847 8.49055C6.23667 8.35312 5.95307 8.12037 5.75354 7.82176C5.55401 7.52314 5.44751 7.17207 5.44751 6.81293C5.44751 6.33133 5.63883 5.86946 5.97936 5.52893C6.3199 5.18839 6.78177 4.99707 7.26337 4.99707Z",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e014f9dea496292e09e2c23badff92ad.svg";
export { ForwardRef as ReactComponent };